import { useState, useRef, useEffect } from 'react';
import Input from '../../../../../components/Input/Input';
import { IChannelGeometryVerticalDropForm, IChannelGeometryProps } from './IChannelGeometry';
import { setGeometry } from '../../../store/project/projectSlice';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { selectProject } from '../../../selector/conversion';
import { useTranslation } from 'react-i18next';
import { SelectCreate } from '../../../../../components/SelectCreate/SelectCreate';
import { cleanResults } from '../../../store/project/resultsSlice';
import { conversionLabel } from '../../../../conversion';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { warning } from '../../../../../components/Alert/Alert';

const bankOptions = [
    { value: 15, label: '15' },
    { value: 30, label: '30' },
    { value: 45, label: '45' },
    { value: 60, label: '60' },
    { value: 75, label: '75' },
    { value: 90, label: '90' },
];

const ChannelGeometryVerticalDrop = (props: IChannelGeometryProps) => {
    let timer = useRef<NodeJS.Timeout | null>(null);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const project = useAppSelector(selectProject);
    const projectInfo = useAppSelector(selectProjectInfo);

    const defaultValue: IChannelGeometryVerticalDropForm = {
        bankTopElevation: project.data!.geometry!.bankTopElevation,
        channelWidth: project.data!.geometry!.channelWidth,
        slopeOfLeftBank: (project.data!.geometry as IChannelGeometryVerticalDropForm).slopeOfLeftBank,
        slopeOfRightBank: (project.data!.geometry as IChannelGeometryVerticalDropForm).slopeOfRightBank,
        id: project.data?.geometry?.id,
        materialId: project.data?.geometry?.materialId,
    };

    const [form, setForm] = useState<IChannelGeometryVerticalDropForm>(defaultValue);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let name = e.target.name;
        let value = parseFloat(e.target.value);

        if (value < 0) {
            value = 0;
            warning(t('warning_not_be_lower', { value: 0 }));
        }

        setForm({
            ...form!,
            [name]: value,
        });
    };

    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            dispatch(cleanResults());
            dispatch(setGeometry(form as IChannelGeometryVerticalDropForm));
        }, 1000);
    }, [form]);

    return (
        <div className='d-flex flex-column gap-2'>
            <Input
                type='number'
                title={t('input_bankTopElevation', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                value={form.bankTopElevation}
                name='bankTopElevation'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <Input
                type='number'
                title={t('input_channelWidth', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                value={form.channelWidth}
                name='channelWidth'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <div className='d-flex justify-content-between align-items-center'>
                <label htmlFor='slopeOfLeftBank'>{t('input_slopeOfLeftBank')}</label>
                <SelectCreate
                    value={form.slopeOfLeftBank}
                    name='slopeOfLeftBank'
                    options={bankOptions}
                    parentOnChange={(newValue: any) =>
                        setForm({
                            ...form!,
                            slopeOfLeftBank: newValue,
                        })
                    }
                />
            </div>
            <div className='d-flex justify-content-between align-items-center'>
                <label htmlFor='slopeOfRightBank'>{t('input_slopeOfRightBank')}</label>
                <SelectCreate
                    value={form.slopeOfRightBank}
                    name='slopeOfRightBank'
                    options={bankOptions}
                    parentOnChange={(newValue: any) =>
                        setForm({
                            ...form!,
                            slopeOfRightBank: newValue,
                        })
                    }
                />
            </div>
        </div>
    );
};

export default ChannelGeometryVerticalDrop;
